import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import './businessUnion.less'

export default {
    name: "businessUnion",
    data() {
        return {
			banner: {
				title: '小精灵数字商盟',
				subTitle: '打造您自己的区域商户联盟平台',
				videoAlign: 'right',
				info: '将分散的商户整合形成商家联盟，打造服务商自己的联盟平台，<br>联合运营，统一变现。',
				features: '· 全系列支付方案，轻松拓店<br>· 全自动门店运营，轻松管店<br>· 多种平台化变现收益',
				tips: '适合：有商户资源、想要实现商户整合变现的区域服务商。',
				btnTxt: '',
				btnHref: '',
				btnType: 'href',
				video: 'video/businessUnion.webm',
				bg: "#5CBCBC"//#08CA09 "#67C3C4" #F6AE15 #FE4F1C #6F7BD5 
			},
			intro1: {
				title: '服务商的经营困局',
				subTitle: '行业内卷严重，企业该如何完成升级和转型？',
				featureList: [
					{
						title: "新开店减慢",
						titleColor: "#6FB9A0",
						pic: 'img/businessUnion/icon1_1.png',
					},
					{
						title: "客户流失多",
						titleColor: "#CF6152",
						pic: 'img/businessUnion/icon1_2.png',
					},
					{
						title: "竞争白热化",
						titleColor: "#EFC151",
						pic: 'img/businessUnion/icon1_3.png',
					},
					{
						title: "业务转型难",
						titleColor: "#D57869",
						pic: 'img/businessUnion/icon1_4.png',
					},
				]
			},
			intro2: {
				title: '长尾商家的数字化痛点',
				subTitle: '面对数字化浪潮，长尾商户该如何抓住数字化变革机遇？',
				featureList: [
					{
						title: "收费太贵门槛高",
						titleColor: "#7B8587",
						pic: 'img/businessUnion/icon2_1.png',
					},
					{
						title: "具体效果无保障",
						titleColor: "#9EC64D",
						pic: 'img/businessUnion/icon2_2.png',
					},
					{
						title: "系统更换嫌麻烦",
						titleColor: "#65A8DD",
						pic: 'img/businessUnion/icon2_3.png',
					},
					{
						title: "人员素质跟不上",
						titleColor: "#8C77B2",
						pic: 'img/businessUnion/icon2_4.png',
					},
				]
			},
			intro3: {
				title: '数字商盟核心亮点',
				subTitle: '以服务商企业为平台主体，利用平台能力“连接”整合区域内的长尾部商户。<br>商户侧：批量输出私域流量运营服务，更好地助力商户实现数字化增长。<br>服务商平台侧：整合商户，获得稳定的运营性收益和多维度的平台变现收益！',
				list: [
					{
						type: 'features',
						title:"商家侧",
						titleBgColor:"#FFC30D",
						subTitle: "",
						pic: 'img/businessUnion/info1.png',
						imgAlign: '',
						features:"<span class='bit-white'>·</span>打通线下能力<br><span class='bit-white'>·</span>双会员能力<br><span class='bit-white'>·</span>储值隔离能力<br><span class='bit-white'>·</span>Ai自动营销能力<br><span class='bit-white'>·</span>联合运营能力<br><span class='bit-white'>·</span>员工分销能力"
					},
					{
						type: 'features',
						title:"平台侧",
						titleBgColor:"#FFC30D",
						subTitle: "",
						pic: 'img/businessUnion/info2.png',
						imgAlign: 'right',
						features:"<span class='bit-white'>·</span>服务商私域能力<br><span class='bit-white'>·</span>微信商家券能力<br><span class='bit-white'>·</span>一店多支付通道能力<br><span class='bit-white'>·</span>广告变现能力<br><span class='bit-white'>·</span>异业合作能力<br><span class='bit-white'>·</span>银行合作能力"
					},
				],
			},
			intro4: {
				title: '全系列收银能力，轻松拓店',
				subtitle: '商盟版提供全系列收银打通工具矩阵，无论商户原来使用什么收银系统，拓店无忧。',
				listTitle: '存量客户翻新',
				listTitleColor: '#5CBCBC',
				list: [
					{
						thumb: '/img/businessUnion/info3.png',
						title: '收款小精灵插件',
						tipsTxt: '适合：所有零售超市客户',
						tipsColor: '#068CF9',
						feature: '·无缝打通市面上99%的收银软件<br>·无需改变原有收银设备、软件、收银习惯<br>·0成本接入、3分钟安装、3秒钟完成移动支付，轻松对账',
					},
					{
						thumb: '/img/businessUnion/info4.png',
						title: '小精灵数字前台',
						tipsTxt: '适合：所有零售超市客户',
						tipsColor: '#068CF9',
						feature: '·3分钟与原有收银系统ERP无缝打通<br>·支持纯键盘，自定义快捷键，操作更便捷<br>·轻量化升级数字零售前台',
					},
				]
			},
			intro5: {
				listTitle: '增量客户拓展',
				listTitleColor: '#5CBCBC',
				list: [
					{
						thumb: '/img/businessUnion/info5.png',
						title: '小精灵收银软件',
						tipsTxt: '适合：中、大型零售商超',
						tipsColor: '#068CF9',
						feature: '·C/S收银，本地部署，稳定抗压<br>·收银&会员全面一体化<br>·线上商城&线下生意一体化·独立版老板助手APP，移动管店',
					},
					{
						thumb: '/img/businessUnion/info6.png',
						title: '小精灵PRO',
						tipsTxt: '适合：大、中、小型零售商超',
						tipsColor: '#068CF9',
						feature: '严选细分行业软件，深度打通小精灵支付、卡券等能力，输出的对应软件的小精灵PRO版本。',
					},
				]
			},
			intro6: {
				listTitle: '其他收银支付方案',
				listTitleColor: '#5CBCBC',
				featureList: [
					{
						title: "收银插件",
						subTitle: "适配市面上99%收银系统",
						pic: 'img/businessUnion/icon3_1.png',
					},
					{
						title: "4G语音王码牌",
						subTitle: "支付+优惠同时播报，刺激消费",
						pic: 'img/businessUnion/icon3_2.png',
					},
					{
						title: "手持收款设备",
						subTitle: "收银、核销、出票、播报一体化",
						pic: 'img/businessUnion/icon3_3.png',
					},
					{
						title: "商户通APP",
						subTitle: "移动客户端，收款、管店于一体",
						pic: 'img/businessUnion/icon3_4.png',
					},
				]
			},
			banner1: {
				pic: 'img/businessUnion/banner1.png',
			},
			intro7: {
				title: '全自动门店运营,轻松管店',
				subTitle: '商盟版为各个行业商户提供海量运营策略模板，<br>商户根据门店情况填写策略，即可轻松完成数字化运营配置。',
				list: [
					{
						type: 'features',
						pic: 'img/businessUnion/info7.png',
						imgAlign: 'right',
						features:"<span class='bit-white'>·</span>数字超市营销策略<br><span class='bit-white'>·</span>数字便利店营销策略<br><span class='bit-white'>·</span>数字药店营销策略<br><span class='bit-white'>·</span>数字生鲜营销策略<br>......."
					},
				],
			},
			intro8: {
				title: '多种平台化收益变现',
				subTitle: '通过区域的商户组网，平台可以拥有多重收益来源和更多的变现方式。',
				featureList: [
					[
						{
							title: "支付收益",
							pic: 'img/businessUnion/icon4_1.png',
						},
						{
							title: "软件收益",
							pic: 'img/businessUnion/icon4_2.png',
						},
						{
							title: "卡券收益",
							pic: 'img/businessUnion/icon4_3.png',
						},
						{
							title: "运营收益",
							pic: 'img/businessUnion/icon4_4.png',
						},
					],
					[
						{
							title: "商品收益",
							pic: 'img/businessUnion/icon4_5.png',
						},
						{
							title: "广告变现",
							pic: 'img/businessUnion/icon4_6.png',
						},
						{
							title: "数据收益",
							pic: 'img/businessUnion/icon4_7.png',
						},
						{
							title: "MORE",
							pic: 'img/businessUnion/icon4_8.png',
						},
					]
				]
			},
            rollList: [
                {
                    src: "/img/businessUnion/roll1.png",
                    size: 2,
                },
                {
                    src: "/img/businessUnion/roll2.png",
                    size: 2,
                },
                {
                    src: "/img/businessUnion/roll3.png",
                    size: 1,
                },
                {
                    src: "/img/businessUnion/roll4.png",
                    size: 2,
                },
				{
					src: "/img/businessUnion/roll5.png",
					size: 2,
				},
				{
					src: "/img/businessUnion/roll6.png",
					size: 2,
				},
            ],
			version: {
				title: '一键升级',
				subTitle: '一键升级高级数字化版本，开启门店降本增效、营收增长之旅！',
				list: [
				{
                    thumb: '/img/payOverview/version1.png',
                    title: '营销优选版',
                    info: '轻量化、全自动的小店数字营销工具，轻松玩转营销活动，实现盈利增长。',
					tag: '10万小店点赞',
					tagColor: '#6370CE',
                    linkTxt: '一键升级',
                    linkHref: '',
                },
				{
                    thumb: '/img/payOverview/version2.png',
                    title: '营销高级版',
                    info: '有效构建企业的“私域流量”能力，并打通“公转私”的闭环方案，为门店生意持续注入活力。',
					tag: '泛行业热门爆款',
					tagColor: '#FF451A',
                    linkTxt: '一键升级',
                    linkHref: '',
				},
				{
                    thumb: '/img/payOverview/version3.png',
                    title: '商盟平台板',
                    info: '专为想要在区域自建“平台”型的服务商打造，将分散的商户整合形成商家联盟，联合运营，统一变现。',
					tag: '资源变现首选',
					tagColor: '#5CBCBC',
                    linkTxt: '一键升级',
                    linkHref: '',
				},
				{
                    thumb: '/img/payOverview/version4.png',
                    title: '餐饮高级版',
                    info: '为餐饮商户提供包括收银、扫码点餐、商城、企业微信、企业钱包等全系列能力，全面赋能餐饮商户的数字化和营收增长。',
					tag: '餐饮全面一体化',
					tagColor: '#F5A416',
                    linkTxt: '一键升级',
                    linkHref: '',
				},
				{
                    thumb: '/img/payOverview/version5.png',
                    title: '零售高级版',
                    info: '为零售商户提供从收银支付、供应链、商品、财务、外卖、员工、私域会员等的闭环解决方案。全面赋能零售商户的数字化和营收增长。',
					tag: '连锁扩张必备',
					tagColor: '#001372',
                    linkTxt: '一键升级',
                    linkHref: '',
				},
				{
                    thumb: '/img/payOverview/version6.png',
                    title: '加油站高级版',
                    info: '为加油站提供数字收银、数字营销、数字管理、数字商城、智慧油站等于一体的全站式解决方案。助力油站真正实现降本、提效、增收。',
					tag: '上万油站推荐',
					tagColor: '#00C409',
                    linkTxt: '一键升级',
                    linkHref: '',
				},
				]
			},
        }
    },
    components: {
        skeleton,
        pay,
        QRCode,
        vueSeamlessScroll
    },
    methods: {
		infoMouseOver(index){
			this.intro6.currentIndex = index
			this.intro6.pic = this.intro6.list[index].pic
		}
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        }
    }
}
